import React from "react";
import SideBar from "../../../common/SideBar";
import HeaderBar from "../../../common/HeaderBar";
import NoticeBoard from "./NoticeBoard";

const NoticeBoardMainPage = () => {
  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <NoticeBoard />
      </div>
    </main>
  );
};

export default NoticeBoardMainPage;

